import { Command } from 'cmdk';
import { Box, Flex, Icon, Text } from '@customerio/pluma-components/react';
import type { ActiveCategory } from './constants';
import type { CategoryFilterOption } from './utils/category-filter-options';

type FilterCategoryCommandGroupProps = {
  activeCategory: ActiveCategory;
  options: CategoryFilterOption[];
  onSelect: (value: ActiveCategory) => void;
};

export function FilterCategoryCommandGroup({ activeCategory, options, onSelect }: FilterCategoryCommandGroupProps) {
  if (options.length === 0) {
    return (
      <Command.Group heading="Filter by category">
        <Box p="100">
          <Text size="xxs" color="subtle">
            No matching categories
          </Text>
        </Box>
      </Command.Group>
    );
  }

  return (
    <Command.Group heading="Filter by category">
      {options.map((option) => (
        <Command.Item
          key={option.value}
          value={`filter-category-${option.value}`}
          onSelect={() => onSelect(option.value)}
          asChild
        >
          <Flex alignItems="flex-start" gap="050">
            <Icon mt="025" name={option.icon} size="sm" sizeVersion="v2" color="base" />
            <Flex direction="column" flex={1} minW="0">
              <Text text="product-p" truncate>
                {option.label}
              </Text>
              <Text size="xxs" color="subtle" truncate>
                {option.value === activeCategory
                  ? 'Currently selected'
                  : option.value === 'all'
                    ? 'Search everything'
                    : `Show only ${option.label.toLowerCase()}`}
              </Text>
            </Flex>
          </Flex>
        </Command.Item>
      ))}
    </Command.Group>
  );
}
